import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import ScanTicketZ from "../components/ScanTicketZ";
const API = process.env.REACT_APP_BACKEND_URL + "/api";
// Accepte 1250,50 comme 1250.50 (clavier francais des telephones).
const nombre = (v) => (v === undefined || v === null || String(v).trim() === "" ? null : parseFloat(String(v).replace(/\s/g, "").replace(",", ".")));
export default function BilanRapidePage() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState("");
  const [d, setD] = useState({ n: "", h: "", t: "", c: "" });
  const [busy, setBusy] = useState(false);
  const [ok, setOk] = useState(false);
  useEffect(() => {
    axios.get(`${API}/kpis-performance/bilan-token/${token}`)
      .then((r) => { setInfo(r.data); if (r.data.deja_rempli) setOk(true); })
      .catch((x) => setErr((x.response && x.response.data && x.response.data.detail) || "Lien invalide"));
  }, [token]);
  const go = async () => {
    const h = nombre(d.h), t = nombre(d.t), n = nombre(d.n);
    if (h === null && t === null) { setErr("Renseignez au moins le chiffre d'affaires"); return; }
    if ((h !== null && isNaN(h)) || (t !== null && isNaN(t))) { setErr("Montant illisible : utilisez des chiffres, par exemple 1250,50"); return; }
    setBusy(true); setErr("");
    try {
      await axios.post(`${API}/kpis-performance/bilan-token/${token}`, {
        nombre_plats: n === null || isNaN(n) ? null : Math.round(n),
        ca_ht: h,
        ca_ttc: t,
        commentaire: d.c || "",
      });
      setOk(true);
    } catch (x) { setErr((x.response && x.response.data && x.response.data.detail) || "Erreur"); }
    setBusy(false);
  };
  const lu = (r) => setD((x) => ({
    ...x,
    ...(r.nombre_plats != null ? { n: String(r.nombre_plats) } : {}),
    ...(r.ca_ht != null ? { h: String(r.ca_ht).replace(".", ",") } : {}),
    ...(r.ca_ttc != null ? { t: String(r.ca_ttc).replace(".", ",") } : {}),
  }));
  const box = { maxWidth: 460, margin: "0 auto", padding: 20, fontFamily: "Arial, sans-serif" };
  const inp = { width: "100%", fontSize: 18, padding: "12px 14px", border: "1px solid #ddd", borderRadius: 8, marginTop: 6, boxSizing: "border-box" };
  const lab = { fontSize: 14, color: "#555", marginTop: 16, display: "block" };
  if (ok) return (<div style={box}><h2 style={{ color: "#7A2D2D" }}>Merci !</h2><p>Votre bilan est enregistré. Vous n'avez plus rien à faire.</p></div>);
  if (err && !info) return (<div style={box}><h2 style={{ color: "#7A2D2D" }}>Lien invalide</h2><p>{err}</p></div>);
  if (!info) return (<div style={box}><p>Chargement...</p></div>);
  return (
    <div style={box}>
      <h2 style={{ color: "#7A2D2D", marginBottom: 4 }}>Bilan de prestation</h2>
      <p style={{ color: "#666", marginTop: 0 }}>{info.event_titre}{info.date ? " — " + String(info.date).slice(0, 10) : ""}</p>
      <p style={{ fontWeight: "bold" }}>{info.food_truck_nom}</p>
      <ScanTicketZ chemin={`/ticket-z/lire/${token}`} onLu={lu} />
      <label style={lab}>Nombre de plats vendus</label>
      <input style={inp} type="text" inputMode="numeric" value={d.n} onChange={(e) => setD({ ...d, n: e.target.value })} />
      <label style={lab}>Chiffre d'affaires HT (€)</label>
      <input style={inp} type="text" inputMode="decimal" placeholder="1250,50" value={d.h} onChange={(e) => setD({ ...d, h: e.target.value })} />
      <label style={lab}>Chiffre d'affaires TTC (€)</label>
      <input style={inp} type="text" inputMode="decimal" placeholder="1375,55" value={d.t} onChange={(e) => setD({ ...d, t: e.target.value })} />
      <label style={lab}>Commentaire (facultatif)</label>
      <input style={inp} value={d.c} onChange={(e) => setD({ ...d, c: e.target.value })} />
      {err && <p style={{ color: "#c00" }}>{err}</p>}
      <button onClick={go} disabled={busy} style={{ width: "100%", marginTop: 22, padding: 16, fontSize: 18, background: "#7A2D2D", color: "#fff", border: 0, borderRadius: 8 }}>
        {busy ? "Envoi..." : "Valider mon bilan"}
      </button>
      <p style={{ color: "#999", fontSize: 12, textAlign: "center", marginTop: 14 }}>Food Truck United</p>
    </div>
  );
}
